import {
  DeleteBeneficiaryResponse,
  GetAllStructuredDataCurrentStatusResponse,
  OutdateAllStructuredDataBeneficiaryResponse,
} from '../../dtos/beneficiary'
import { RequestPayload } from '../../dtos/generic'
import { defineRoute } from '../new-helpers'
import { adminControllerPath } from './admin'

export const adminBeneficiariesControllerPath = adminControllerPath + 'beneficiaries/'

export const AdminBeneficiariesRoutes = {
  deleteOne: defineRoute<'DELETE', DeleteBeneficiaryResponse>({
    path: `${adminBeneficiariesControllerPath}:beneficiaryId`,
  }),
  outdateStructuredDataForAll: defineRoute<
    'PATCH',
    OutdateAllStructuredDataBeneficiaryResponse,
    RequestPayload<{ origin: string }>
  >({
    path: `${adminBeneficiariesControllerPath}outdateAllStructuredData`,
  }),
  getAllStructuredDataCurrentState: defineRoute<'GET', GetAllStructuredDataCurrentStatusResponse>({
    path: `${adminBeneficiariesControllerPath}getAllStructuredDataCurrentState`,
  }),
}
